import React, { useState, useEffect } from "react";
import Header from "./Components/Header/Header";
import Nav from "./Components/Nav/Nav";
import About from "./Components/About/About";
import Services from "./Components/Services/Services";
import Portfolio from "./Components/Portfolio/Portfolio";
import Contact from "./Contact/Contact";
import Footer from "./Components/Footer/Footer";
import Testimonials from "./Components/Testimonials/Testimonials";
import { Experience } from "./Components/Experience/Experience";
import { Modal } from "./Components/Modal/Modal";
import Container from "./Components/Style/Container";
import { GlobalStyle } from "./Components/Style/globalStyle";

import "bootstrap/dist/css/bootstrap.min.css";
// Loaders
// import RingLoader from "react-spinners/RingLoader";
// import XmasLoader from './Components/XmasLoader/XmasLoader';
import "./App.css";
// import Monster from './Components/Monster/Monster'
// Animations
import AOS from "aos";
import "aos/dist/aos.css";

function App() {
	const [loading, setLoading] = useState(false);
	const [showModal, setShowModal] = useState(true);

	useEffect(() => {

		// create a delay for the loader
	

		setLoading(true);
		AOS.init();
		AOS.refresh();

		setTimeout(() => {
			setLoading(false);
		}, 7000);

		// window.addEventListener("load", () => {
		// 	setLoading(false);
		// }); -- undo this when you no longer need to display Modal
	}, []);

	return (
		<div className="App">
			{loading ? (
				<Container>
					<Modal showModal={showModal} setShowModal={setShowModal} />
					<GlobalStyle />
				</Container>
			) : (
				<div className="content">
					{/* <Monster draw={draw} /> */}
					<Header />
					<Nav />
					<About />
					<Experience />

					<Services />
					<Portfolio />
					<Testimonials />
					<Contact />
					<Footer />
				</div>
			)}
		</div>
	);
}

export default App;
